var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext, } from 'react';
export var BottomBubbleContext = createContext(function () { });
export var useBottomBubble = function () {
    return useContext(BottomBubbleContext);
};
export var withBottomBubble = function (Component) {
    var WithBottomBubble = function (props) {
        var setBottomBubble = useBottomBubble();
        // eslint-disable-next-line react/jsx-props-no-spreading
        return React.createElement(Component, __assign({}, props, { setBottomBubble: setBottomBubble }));
    };
    WithBottomBubble.displayName = "withBottomBubble(".concat(Component.displayName || Component.name || 'Component', ")");
    return WithBottomBubble;
};
